function submitFilterForm(url/*categories, url*/) {
    /*var data = getFilterFormData();
    if (categories)
        url = buildCategoryUrl(categories, url);
    else
        url = buildCategoryFilterUrl();
    if (data)
        url += '?' + data;*/

    var options = {
        type: 'POST',
        container: '#category-pjax-container',
        data: $("#pjax-form").serialize()
    };

    if (url) {
        options.url = url;
    }

    $.pjax(options);
    return false;
}

export {submitFilterForm}